<template>
    <div class="header">
        <h3 class="form-step-header">{{title}}</h3>
        <div class="form-step-description" v-if="description !== ''" v-html="description"></div>
    </div>
</template>

<script>
export default {
    name: "design-2021-apprentice-multistep-form-wizard-form-header-component",
    props: {
        title: {
            type: String,
            required: true,
        },

        description: {
            type: String,
            required: false,
            default: '',
        },
    }
}
</script>

<style scoped lang="scss">
    .form-step-header {
        margin-bottom: map-get($grid-gutter-spacing, 'eight');
    }

    .form-step-description {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
        line-height: 1.5;
        margin-bottom: $grid-gutter-width;
    }
</style>
